<template>
  <div>
    <!--
<v-row justify="center" class="ma-0 pa-0">
  <v-col cols="2"></v-col>
  <v-col cols="12"  sm="10" md="10" lg="10">
    <v-divider class="mb-4"></v-divider>
  </v-col>
 


    </v-row>-->

    <v-row justify="center" class="ma-0 pa-0" v-if="seotxt1 !== ''">
      <v-col cols="2" v-if="$vuetify.breakpoint.mdAndUp" class="pa-0"></v-col>
      <v-col cols="12" sm="10" md="10" lg="10" class="text-left pa-0">
        <v-row class="ma-0 px-0 pb-2">
          <v-col cols="12" sm="12" md="10" lg="10" class="pa-xs-1 ">
            <!-- <div class="title">SEO текст</div> -->
            <div v-html="seotxt1" class="shop-description"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="end" class="ma-0 pa-0" v-if="seogallery.length !== 0">
      <v-col cols="12" sm="8" md="8" lg="12" xl="12" class="pa-0">
        <SwiperSEO :listImage="seogallery" />
      </v-col>
    </v-row>

    <v-row justify="center" class="ma-0 pa-0 ">
      <v-col cols="2" v-if="$vuetify.breakpoint.mdAndUp" class="pa-0"></v-col>
      <v-col cols="12" sm="10" md="10" lg="10" class="text-left px-0">
        <v-row class="ma-0 pa-0">
          
          <v-col cols="12" sm="12" md="10" lg="10" class="pa-xs-1 pa-sm-0">
            <div v-html="seotxt2" class="shop-description"></div>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pa-0"></v-col>
    </v-row>

    <v-row class="ma-0 pa-0" v-if="isMobile">
      <v-col cols="12" class="bottom-empty">

      </v-col>
    </v-row>
  </div>
</template>

<script>
import SwiperSEO from "@/components/SwiperSEO";

export default {
  name: "SeoBlock",
  
  props: {
    seotxt1:{
      type:String,
      default:''
    },
    seotxt2:{
      type:String,
      default:''
    },
    seogallery:{
      type: Array,
      default:[]
    }
     },
  components: {
    SwiperSEO,
  },
  data: () => ({}),
  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    isMobile: {
      get () {
        return this.$store.state.app.isMobile
      }
      
    },
  },
};
</script>
<style scoped>
.phone-link a {
  color: #336;
  text-decoration: underline;
}
.phone-link a:hover {
  text-decoration: unset;
}
.bottom-empty{
  height: 100px;
}
</style>